import { useMemo } from 'react';
import { useQuery } from 'react-query';
import NaurService from '../../services/naurService';
import useAbortController from '../useAbortController';

/**
 * Hook to check NAUR compliance status for a property
 *
 * @param {Object} params - Hook parameters
 * @param {string} params.propertyId - The property ID to check
 * @param {Object} params.options - Optional React Query options
 * @returns {Object} - { hasNonCompliantBuildings, isLoading, error, data }
 */
const usePropertyNaurCompliance = ({
  propertyId,
  options,
}: {
  propertyId?: string,
  options?: Object,
}) => {
  const naurComplianceService = useMemo(() => new NaurService(), []);
  const abortControllerOptions = useAbortController();

  const queryKey = ['property-naur-compliance', propertyId];

  return useQuery(
    queryKey,
    () =>
      naurComplianceService.getPropertyCompliance(
        propertyId,
        abortControllerOptions,
      ),
    {
      enabled: Boolean(propertyId?.length),
      refetchOnWindowFocus: false,
      ...options,
    },
  );
};

export default usePropertyNaurCompliance;
